
import { useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/components/AuthProvider';
import { toast } from 'sonner';

export const useSubscriptionStatusCheck = () => {
  const { user, profile, refreshProfile } = useAuth();

  const checkSubscriptionStatus = useCallback(async () => {
    if (!user || !profile) return;

    try {
      // Check if subscription is expired locally first
      if (profile.subscription_end_date) {
        const endDate = new Date(profile.subscription_end_date);
        const now = new Date();
        
        if (endDate < now && (profile.subscription_status === 'active' || profile.subscription_status === 'trialing')) {
          console.log('Local check: subscription expired, calling edge function');
          
          // Call edge function to update expired subscriptions
          const { error } = await supabase.functions.invoke('check-expired-subscriptions');
          
          if (error) {
            console.error('Error calling check-expired-subscriptions:', error);
          } else {
            // Refresh profile to get updated status
            await refreshProfile();
            
            // Show notification to user
            toast.warning('Sua subscrição expirou. Faça upgrade para continuar usando todas as funcionalidades.');
          }
        }
      }
    } catch (error) {
      console.error('Error checking subscription status:', error);
    }
  }, [user, profile, refreshProfile]);

  // Check on mount and when user/profile changes
  useEffect(() => {
    checkSubscriptionStatus();
  }, [checkSubscriptionStatus]);

  // Periodic check every 10 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      checkSubscriptionStatus();
    }, 10 * 60 * 1000); // 10 minutes

    return () => clearInterval(interval);
  }, [checkSubscriptionStatus]);

  return {
    checkSubscriptionStatus
  };
};
